import { useEffect} from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
} from "@mui/material";
import { JumboCard } from "themes/jumbo/@jumbo/components";
import { ProjectItem, EmptyProjectItem } from "./ProjectItem";
import { useSelector } from 'react-redux';
import { tss } from "tss-react";
import { useHistory } from 'react-router-dom';
import AuthService from "services/AuthService";

const useStyles = tss.create(() => ({
	tableTr: {
		borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
		textAlign: 'left',
		padding: '16px',
		color: 'rgb(71, 82, 89)',
		borderTopColor: 'rgba(0, 0, 0, 0.1)',
		borderRightColor: 'rgba(0, 0, 0, 0.1)',
		bordTransform: 'uppercase',
		//letterSpacing: '1.5px',
		fontWeight: 600,
		fontSize: '14px',
		lineHeight: 1.25,
		background: 'rgba(0, 0, 0, .08)'
	}
}));
const ProjectsList = (props:any) => {
 	const {nb} = props
	const _projects = useSelector((state: any) => state.cache.data.projects);
	const storeAuthData = useSelector((state: any) => state.auth);
  	const { defaultProjects } = storeAuthData;

	const { classes } = useStyles();
	const history = useHistory();
  	const demoProjectsHidden = Number(localStorage.getItem('hideDemoProjects') || 0) > 0;
  	const projects = Object.values(_projects).filter((item: any) => !demoProjectsHidden || !defaultProjects.includes(item.ID));

	const handleClick = (e: any) => {
		history.push(`/catalog`);
	};

	// useEffect(() => {
	// 	const defaultProjectsLoaded = localStorage.getItem("FirstReload_" + btoa(AuthService.userEmail));
	// 	if(defaultProjectsLoaded !== null){
	// 		localStorage.removeItem("FirstReload_" + btoa(AuthService.userEmail));
	// 		setTimeout(() => {
	// 			window.location.reload();
	// 		}, 1000);
	// 	}
	// });
    

  	return (
		<JumboCard>
		<TableContainer sx={{minHeight: '420px'}}>
			<Table /*sx={{ minWidth: 400 }}*/>
			<TableHead>
				<TableRow
				sx={{
					"th:first-of-type": {
					pl: 3,
					},
					"th:last-child": {
					pr: 3,
					},
				}}
				>
				<TableCell className={classes.tableTr}>PROJECTS {nb > 0 ? `(${nb})` : ''}</TableCell>
				<TableCell className={classes.tableTr} sx={{ display: {xs: 'none', sm: 'none', md: 'table-cell', lg:'table-cell', xl: 'table-cell'}}}></TableCell>
				<TableCell className={classes.tableTr} style={{textAlign: 'right'}} sx={{ display: {xs: 'none', sm: 'none', md: 'table-cell', lg:'table-cell', xl: 'table-cell'}}}>
				<Button
					size={'small'}
					variant='outlined'
					onClick={handleClick}
          			style={{whiteSpace: 'nowrap'}}
					sx={{ml: {xs: '-60px'}}}
				>
					All Projects
				</Button>
				</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{projects.length > 0 ?  (
				  projects.slice(0, 6).map((item: any, index: Number) => (
					<ProjectItem item={item} key={`${item.ID}-${index}`} index={index} isDefaultProject={defaultProjects.includes(item.ID)} />
				))
				) : (
				<EmptyProjectItem />
				)}
			</TableBody>
			</Table>
		</TableContainer>
		</JumboCard>
  	);
};
export { ProjectsList };
